import React from 'react';
import PersonIcon from '@mui/icons-material/Person';
import DeleteIcon from '@mui/icons-material/Delete';

export type Student = {
  id: string;
  full_name: string;
  birth_date?: string;
  phone?: string;
  address?: string;
  position?: string;
  email?: string;
  snils?: string;
  login?: string;
  password?: string;
  updated_at?: string;
};

interface StudentListItemProps {
  student: Student;
  onClick: () => void;
  onDelete: () => void;
  isSelected: boolean;
}

export const StudentListItem: React.FC<StudentListItemProps> = ({
  student,
  onClick,
  onDelete,
  isSelected
}) => {
  const handleDeleteClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDelete();
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onClick()}
      className={`w-full text-left rounded-lg border p-4 shadow-sm transition-all cursor-pointer focus:outline-none ${
        isSelected
          ? 'bg-blue-50 border-blue-400 shadow-md'
          : 'bg-white border-gray-200 hover:border-blue-400 hover:shadow-md'
      }`}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <PersonIcon className={isSelected ? 'text-blue-600' : 'text-gray-400'} />
          <span className={`font-medium truncate ${isSelected ? 'text-blue-800' : 'text-gray-800'}`}>
            {student.full_name}
          </span>
        </div>

        <button
          type="button"
          onClick={handleDeleteClick}
          aria-label={`Удалить студента ${student.full_name}`}
          className="flex-shrink-0 p-1.5 rounded-md text-gray-400 hover:bg-red-50 hover:text-red-600 focus:outline-none transition-colors"
        >
          <DeleteIcon fontSize="small" />
        </button>
      </div>
    </div>
  );
};